import { Context, CustomQuery } from '@vue-storefront/core';
import { ShippingProvider, ShippingMethod, ApiResult } from '../../types';

export default async function customShippiingProvider(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/shipping/get', context.config.api.url);

  const { data: res } = await context.client.post(url.href, params);
  if (res.code === 0) {
    const data = res.data;
    const allShippingMethods: ShippingProvider = {
      list: []
    };

    if (data && data.List) {
      // 循环list
      data.List.forEach((x) => {
        const shippingMethod: ShippingMethod = {
          shipId: x.ship_id,
          shopId: x.shop_id,
          title: x.title,
          price: x.price,
          isOpen: x.is_open,
          delivery: x.delivery,
          value: x.value,
          description: x.description,
          createAt: x.create_at,
          updateAt: x.update_at
        };
        allShippingMethods.list.push(shippingMethod);
      });
    }
    res.data = allShippingMethods;
  }

  return res;
}
